<template>
  <section id="dashboard-ecommerce">
    <div v-if="$can('read', 'dashboard')" class="mb-2">
      <h3 class="mb-2">Organization Dashboard</h3>
      <organization-dashboard />
      <hr class="my-3">
      <h3 class="mb-2">Personal Dashboard</h3>
    </div>
    <b-row class="match-height">
      <b-col lg="4" cols="12">
        <process-card :mine="true" :data="data.processes" />
      </b-col>
      <b-col lg="4" cols="12">
        <tasks :mine="true" :data="data.lateTasks" />
      </b-col>
      <b-col lg="4" cols="12">
        <roles :mine="true" :data="data.roles" />
      </b-col>
    </b-row>
  </section>
</template>

<script>
  import { BRow, BCol } from 'bootstrap-vue'

  import { mapActions, mapState } from 'vuex'
  import Roles from '@/views/dashboard/statsCard/OrgRolesCard.vue'
  import Tasks from '@/views/dashboard/statsCard/Tasks.vue'
  import ProcessCard from './statsCard/ProcessCard.vue'
  import OrganizationDashboard from './OrganizationDashboard.vue'

  export default {
    components: {
      BRow,
      BCol,
      Roles,
      Tasks,
      ProcessCard,
      OrganizationDashboard,
    },
    data() {
      return {
        data: {},
      }
    },
    computed: {
      ...mapState('stats', ['personalStatistics', 'pIsLoading']),
    },
    created() {
      this.getUserStatistics().then(() => {
        this.data = this.personalStatistics
      })
    },
    methods: {
      ...mapActions('stats', [
        'fetchPersonalStatisticsIfNotLoaded',
        'getUserStatistics',
      ]),
    },
  }
</script>

<style lang="scss">
  @import '../../@core/scss/vue/pages/dashboard-ecommerce';
  @import '../../@core/scss/vue/libs/chart-apex';
</style>
